import { Col, Row } from 'antd';
import React from 'react';
import CoverageStatusConnections from '../../CoverageStatusConnections';

const TestConnectionContent = props => {
  return (
    <Row
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Col span={12}>
        <CoverageStatusConnections {...props} />
      </Col>
    </Row>
  );
};

export default TestConnectionContent;
